import React, { useState, useEffect } from 'react';
import { classNames } from 'primereact/utils';
import { Link, useNavigate } from 'react-router-dom';
import AppBreadcrumb from './AppBreadcrumb';
import AppMenu from './AppMenu';
import Authentication from './components/session/index'
import { connect, useDispatch } from 'react-redux';
import { API_ENDPOINT } from './service/config';
import withRouter from './components/lib/withRouter';
import { Dropdown } from 'primereact/dropdown';
import ClassetDropdown from './classetComponents/classetDropDown';
import { userSignOut, setLanguage } from './store/actions';
import { ProgressSpinner } from 'primereact/progressspinner';

const AppTopbar = (props) => {
    const notificationsItemClassName = classNames('notifications-item', { 'active-menuitem': props.topbarNotificationMenuActive });
    const navigate = useNavigate();
    const dispatch = useDispatch();
    
    // State to track the current academic year
    const [currentAcademicYear, setCurrentAcademicYear] = useState(
        localStorage.getItem('userAcademicYear') || props?.selectedOption
    );

    // Listen for academic year changes
    useEffect(() => {
        // Listen for custom events from enquiry form
        const handleAcademicYearChange = (event) => {
            const { academicYearId } = event.detail;
            setCurrentAcademicYear(academicYearId);
            
            // Update the parent component's state if needed
            if (props.onChangeDropOption) {
                props.onChangeDropOption(academicYearId);
            }
        };

        // Listen for localStorage changes
        const handleStorageChange = (e) => {
            if (e.key === 'userAcademicYear') {
                setCurrentAcademicYear(e.newValue);
                
                // Update the parent component's state if needed
                if (props.onChangeDropOption) {
                    props.onChangeDropOption(e.newValue);
                }
            }
        };

        // Add event listeners
        window.addEventListener('academicYearChanged', handleAcademicYearChange);
        window.addEventListener('storage', handleStorageChange);

        // Initial sync from localStorage
        const storedAcademicYear = localStorage.getItem('userAcademicYear');
        if (storedAcademicYear && storedAcademicYear !== currentAcademicYear) {
            setCurrentAcademicYear(storedAcademicYear);
        }

        // Cleanup event listeners
        return () => {
            window.removeEventListener('academicYearChanged', handleAcademicYearChange);
            window.removeEventListener('storage', handleStorageChange);
        };
    }, [currentAcademicYear, props.onChangeDropOption]);

    const dropdownItemClassName = classNames('profile-item', { 'active-menuitem': props.academicYearOptions });
    const profileItemClassName = classNames('profile-item', { 'active-menuitem fadeInDown': props.topbarUserMenuActive });

    const handleAcademicYearChange = (academicYearId) => {
        // Update local state
        setCurrentAcademicYear(academicYearId);
        
        // Update localStorage
        localStorage.setItem('userAcademicYear', academicYearId);
        
        // Trigger custom event for other components to listen
        window.dispatchEvent(new CustomEvent('academicYearChanged', {
            detail: { academicYearId }
        }));
        
        // Call the parent's change handler
        if (props.onChangeDropOption) {
            props.onChangeDropOption(academicYearId);
        }
    };

    return (
        <div className="layout-topbar">
            <div className="topbar-left">
                <button type="button" className="menu-button p-link" onClick={props.onMenuButtonClick}>
                    <i className="pi pi-chevron-left"></i>
                </button>

                <Link to="/">
                    <img id="logo-horizontal" className="horizontal-logo" src="classet-favicon-logo.png" alt="diamond-layout" />
                </Link>

                <span className="topbar-separator"></span>

                <div className="layout-breadcrumb viewname">
                    <AppBreadcrumb meta={props.meta} />
                </div>

                <img id="logo-mobile" className="mobile-logo" src="classet-favicon-logo.png" alt="diamond-layout" />
            </div>

            <AppMenu
                model={props.menu}
                menuMode={props.menuMode}
                active={props.menuActive}
                mobileMenuActive={props.staticMenuMobileActive}
                onMenuClick={props.onMenuClick}
                onMenuitemClick={props.onMenuitemClick}
                onRootMenuitemClick={props.onRootMenuitemClick}
            ></AppMenu>

            <div className="layout-mask modal-in"></div>

            <div className="topbar-right">
                <ul className="topbar-menu">
                    <li className={dropdownItemClassName}>
                        {props?.academicYearOptions?.length ? (
                            <ClassetDropdown
                                options={props?.academicYearOptions}
                                optionLabel="academicCode"
                                width={'195px'}
                                height={'35px'}
                                optionValue='_id'
                                fromScreen="NavTopBar"
                                className="p-link"
                                value={currentAcademicYear}
                                showClear={false}
                                onChange={(event) => handleAcademicYearChange(event.target.value)}
                            />
                        ) : (
                            <ProgressSpinner style={{ width: '34px', height: '34px' }} strokeWidth="4" fill="var(--surface-ground)" animationDuration=".5s" />
                        )}
                    </li>
                    <li className={profileItemClassName}>
                        <button type="button" className="p-link" onClick={props.onTopbarUserMenu}>
                            <img src="profilew.jpg" alt="diamond-layout" className="profile-image" />
                            <span className="profile-name">{localStorage.getItem('name')?.toUpperCase() || ''}</span>
                        </button>
                        <ul className="profile-menu fade-in-up">
                            <li>
                                <button type="button" onClick={() => { navigate('/login'); dispatch(userSignOut()); }} className="p-link">
                                    <i className="pi pi-power-off"></i>
                                    <span>Logout</span>
                                </button>
                            </li>
                        </ul>
                    </li>

                    <li className="right-sidebar-item">
                    </li>
                </ul>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    user: state.user?.user,
});

const mapDispatchToProps = (dispatch) => ({
    userSignOut: () => dispatch(userSignOut()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Authentication(withRouter(AppTopbar)));